$('.privacy-acc').on('click', function () {
  $(this).toggleClass('active')
  $(this).next().slideToggle()
})

$('.you-vi').on('click', function () {
  const index = $(this).index()
  openModal($('.modallist-item').eq(index))
  return false
})

let scrollTop
// モーダル開く
function openModal(el) {
  let elModal = el.children('.modal')
  let elModalContent = elModal.children('.modal')
  scrollTop = $(window).scrollTop()
  elModal.addClass('active')
  elModal.scrollTop(0)
  $('body').addClass('lock')
  $('body').css({ top: -1 * scrollTop })
  if (navigator.userAgent.indexOf('iPhone') !== -1 || navigator.userAgent.indexOf('iPad') !== -1) {
    for (let i = 0; i < elModalContent.length; i++) {
      elModalContent[i].addEventListener(
        'touchmove',
        function (e) {
          const scroll = elModalContent.scrollTop
          const range = elModalContent.scrollHeight - elModalContent.offsetHeight - 1
          if (scroll < 1) {
            e.preventDefault()
            elModalContent.scrollTop = 1
          } else if (scroll > range) {
            e.preventDefault()
            elModalContent.scrollTop = range
          }
        },
        { passive: false }
      )
    }
  }
}

// モーダル閉じる
$('.modal').on('click', function () {
  closeModal($(this))
})
$('.modal-content').on('click', function (e) {
  e.stopPropagation()
})
function closeModal(el) {
  el.removeClass('active')
  $('body').removeClass('lock')
  $(window).scrollTop(scrollTop)
}
